import Cookies from 'js-cookie';
import { getDefaultConfig } from 'Utils/Store';

// Heap Integration
export function loadHeap() {
  if (typeof window !== 'undefined') {
    ensureHeapReadyCbExist();
    (window.heap = window.heap || []),
      (window.heap.load = function (e, t) {
        (window.heap.envId = e),
          (window.heap.clientConfig = t = t || {}),
          (window.heap.clientConfig.shouldFetchServerConfig = !1);
        var a = document.createElement('script');
        (a.type = 'text/javascript'),
          (a.async = !0),
          (a.src = 'https://cdn.us.heap-api.com/config/' + e + '/heap_config.js');
        var r = document.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(a, r);
        var n = [
            'init',
            'startTracking',
            'stopTracking',
            'track',
            'resetIdentity',
            'identify',
            'identifyHashed',
            'getSessionId',
            'getUserId',
            'getIdentity',
            'addUserProperties',
            'addEventProperties',
            'removeEventProperty',
            'clearEventProperties',
            'addAccountProperties',
            'addAdapter',
            'addTransformer',
            'addTransformerFn',
            'onReady',
            'addPageviewProperties',
            'removePageviewProperty',
            'clearPageviewProperties',
            'trackPageview',
          ],
          i = function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments, 0);
              window.heapReadyCb.push({
                name: e,
                fn: function () {
                  window.heap[e] && window.heap[e].apply(window.heap, t);
                },
              });
            };
          };
        for (var p = 0; p < n.length; p++) window.heap[n[p]] = i(n[p]);
      });
    window.heap.load(getHeapId());
  }
}

function ensureHeapReadyCbExist() {
  let heapReadyCb = window.heapReadyCb;
  if (!heapReadyCb) {
    heapReadyCb = [];
    window.heapReadyCb = heapReadyCb;
  }
  return heapReadyCb;
}

export const heapIdentify = (profileId) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.heap.identify(profileId);
};

export const getHeapCDC = async () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (!window.heap?.loaded) {
    const heapLoadPromise = new Promise((resolve) => {
      ensureHeapReadyCbExist().push({
        name: 'getHeapCDC-wait-load',
        fn: resolve,
      });
    });
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(resolve, 5000);
    });

    await Promise.race([heapLoadPromise, timeoutPromise]);
  }

  const heap = window.heap;
  if (!heap?.loaded) {
    return undefined;
  }

  if (heap) {
    const envId = heap.appid ?? getHeapId() ?? '';

    const userId = heap.getUserId() ?? '';

    const sessionId = heap.getSessionId() ?? '';

    const sessionStartTime = getHeapSessionStartTime(envId);

    const identity = heap.getIdentity() ?? '';

    return [envId, userId, sessionId, sessionStartTime, identity].join(';');
  }

  return undefined;
};

function getHeapId() {
  const { heapId } = getDefaultConfig();
  return heapId;
}

function getHeapSessionStartTime(envId) {
  const metaCookieAsString = Cookies.get(`_hp5_meta.${envId}`);
  let metaCookie = undefined;
  if (metaCookieAsString) {
    try {
      metaCookie = JSON.parse(metaCookieAsString);
    } catch (error) {
      // Ignore.
    }
  }
  return metaCookie?.sessionProperties?.time ?? '';
}
